export default "__VITE_PUBLIC_ASSET__25a53db7__"